import { render, staticRenderFns } from "./TreatmentList.vue?vue&type=template&id=1025ec62&scoped=true&lang=pug"
import script from "./TreatmentList.vue?vue&type=script&lang=js"
export * from "./TreatmentList.vue?vue&type=script&lang=js"
import style0 from "./TreatmentList.vue?vue&type=style&index=0&id=1025ec62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1025ec62",
  null
  
)

export default component.exports